import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { api } from "../../Appjs/api.js";

// export const reportApi = createApi({
//   reducerPath: "reportApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: `${api}/report/`,
//     prepareHeaders: (headers) => {
//       const token = localStorage.getItem("accessToken");
//       if (token) {
//         headers.set("Authorization", `Bearer ${token}`);
//       }
//       return headers;
//     },
//   }),

// import { createApi } from "@reduxjs/toolkit/query/react";
// import { secureBaseQuery } from "./secureBaseQuery.js";

// const addReportPrefix = (url = "") => {
//   const cleanUrl = String(url).replace(/^\/+/, "");
//   return `/report/${cleanUrl}`;
// };

// const reportSecureBaseQuery = async (args, apiData, extraOptions) => {
//   if (typeof args === "string") {
//     return secureBaseQuery(addReportPrefix(args), apiData, extraOptions);
//   }

//   return secureBaseQuery(
//     {
//       ...args,
//       url: addReportPrefix(args.url),
//     },
//     apiData,
//     extraOptions
//   );
// };

export const reportApi = createApi({
  reducerPath: "reportApi",
    baseQuery: fetchBaseQuery({
    baseUrl: `${api}/report/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSmsUploadSummary: builder.query({
      query: ({ startdate, enddate, file_status, page = 1, limit = 25 }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        if (file_status) params.append("file_status", file_status);
        params.append("page", page);
        params.append("limit", limit);

        return `get/smsupload_id?${params.toString()}`;
      },
    }),

    getDownloadCampaignCSV: builder.mutation({
      query: ({ campaign_id, stat }) => {
        const params = new URLSearchParams();
        params.append("campaign_id", campaign_id);
        if (stat) params.append("stat", stat);

        return {
          url: `download/numbers_by_campaign?${params.toString()}`,
          method: "GET",
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
          cache: "no-cache",
        };
      },
    }),

    requestSmsDownload: builder.mutation({
      query: ({ campaign_ids, report_type }) => ({
        url: "download/request-sms",
        method: "POST",
        body: {
          campaign_ids,
          report_type,
        },
      }),
    }),

    getCustomerReport: builder.query({
      query: ({
        startdate,
        enddate,
        file_status,
        username,
        page = 1,
        limit = 25,
      }) => {
        const params = new URLSearchParams();

        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        if (file_status) params.append("file_status", file_status);
        if (username) params.append("username", username);

        params.append("page", page);
        params.append("limit", limit);

        return `get-customer-report?${params.toString()}`;
      },
    }),
    getNumbersByCampaign: builder.query({
      query: ({ campaign_id, page, stat }) => {
        const params = new URLSearchParams();
        params.append("campaign_id", campaign_id);
        params.append("page", page);
        if (stat) params.append("stat", stat);
        return `get/numbers_by_campaign?${params.toString()}`;
      },
    }),

    getNumbersBySearch: builder.query({
      query: ({ campaign_id, ph_no }) =>
        `search/numbers?campaign_id=${campaign_id}&ph_no=${ph_no}`,
    }),
    getSearchAcrossCampaigns: builder.query({
      query: ({ ph_no, startDate, endDate, page = 1 }) =>
        `search/number-campaigns?ph_no=${ph_no}&start_date=${startDate}&end_date=${endDate}&page=${page}`,
    }),

getApiSmsUploadSummary: builder.query({
  query: ({ startdate, enddate, sms_status, page = 1, limit = 25 }) => {
    const params = new URLSearchParams();
    
    if (startdate) params.append("startdate", startdate);
    if (enddate) params.append("enddate", enddate);
    if (sms_status && sms_status !== "ALL") {
      params.append("sms_status", sms_status);
    }
    params.append("page", page);
    params.append("limit", limit);
    
    // Return as string URL (same pattern as working getSmsUploadSummary)
    return `get/api/smsupload_id?${params.toString()}`;
  },
}),

    getApiSmsByPhoneSearch: builder.query({
      query: (phoneNumber) =>
        `search/api/sms/by-phone?phoneNumber=${phoneNumber}`,
    }),
 getTodayApiSmsReportCSV: builder.mutation({
  query: () => ({
    url: `get/api/sms/today/download`,
    method: "GET",
    responseHandler: async (response) => {
      const contentType = response.headers.get("content-type");
      
      // If response is JSON (error message)
      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        // Throw error with the message
        throw { data: errorData };
      }
      
      // Otherwise return blob for successful download
      const blob = await response.blob();
      return {
        fileName: `today_sms_report.csv`,
        blob,
      };
    },
  }),
}),
    CeateMonthlyReportByCustomer: builder.mutation({
      query: (data) => ({
        url: `/create-customer-monthly-report`,
        method: "POST",
        body: data,
      }),
    }),
    getCustomerMonthlyReport: builder.query({
      query: () => ({
        url: "/get-customer-monthly-report",
        method: "GET",
      }),
    }),

    getCustomerLogDeleteKey: builder.query({
      query: () => ({
        url: "/get-customer-log-delete-key",
        method: "GET",
      }),
    }),

    deleteLogReport: builder.mutation({
      query: ({ campaign_id }) => ({
        url: `delete-log-report`,
        method: "PATCH",
        body: { campaign_id },
      }),
    }),

    getConsolidatedReport: builder.query({
      query: ({ startdate, enddate }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        return `get-consolidated-report?${params.toString()}`;
      },
    }),

    getDeliveryStatusCount: builder.query({
      query: ({ startdate, enddate }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        return `get-delivery-status-count?${params.toString()}`;
      },
    }),

    getResellerCustomers: builder.query({
      query: () => `get-reseller-customer`,
    }),

    getDownloadColumnNames: builder.mutation({
      query: (fileType = "csv") => ({
        url: `download-column-names?fileType=${fileType}`,
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          return {
            fileName: `column_names.${fileType === "excel" ? "xlsx" : "csv"}`,
            blob,
          };
        },
      }),
    }),

    getDashboardReport: builder.query({
      query: () => `get/dashboard-report`,
    }),
    getLastMonthTraffic: builder.query({
      query: () => `get/last-month-traffic`,
    }),

    getLast7DaysTraffic: builder.query({
      query: () => `get/last-7-days-traffic`,
    }),

    checkFailedRefund: builder.query({
      query: () => ({
        url: "check-failed-refund",
        method: "GET",
      }),
    }),

    getHourlyMISReport: builder.query({
      query: ({ month, year }) =>
        `get-hourly-mis-report?month=${month}&year=${year}`,
    }),

    getResellerHourlyMISReport: builder.query({
      query: ({ month, year }) =>
        `get-reseller-hourly-mis-report?month=${month}&year=${year}`,
    }),

    getHourlyMISDetails: builder.query({
      query: ({ day, hour, month, year, customerId }) =>
        `get-hourly-mis-details?day=${day}&hour=${hour}&month=${month}&year=${year}${customerId ? `&customerId=${customerId}` : ""
        }`,
    }),
    downloadSmsReport: builder.mutation({
      query: (body) => ({
        url: "download/request", // ✅ FIXED
        method: "POST",
        body,
      }),
    }),
    getDownloadRequestList: builder.query({
      query: ({ report_type_id, startdate, enddate, page = 1, limit = 25 }) => {
        const params = new URLSearchParams();
        if (report_type_id) params.append("Report_type_id", report_type_id);
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        params.append("page", page);
        params.append("limit", limit);
        return `get-download-request?${params.toString()}`;
      },
    }),

    searchResellerNumberCampaigns: builder.query({
      query: ({ ph_no, startDate, endDate, page = 1 }) => {
        const params = new URLSearchParams();
        if (ph_no) params.append("ph_no", ph_no);
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        params.append("page", page);

        return `search/reseller-number-campaigns?${params.toString()}`;
      },
    }),
    getResellerDeliveryStatusCount: builder.query({
      query: ({ startdate, enddate }) => {
        const params = new URLSearchParams();

        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);

        return `get-reseller-delivery-status-count?${params.toString()}`;
      },
    }),
    downloadSmsReportByDate: builder.mutation({
  query: ({ start_date, end_date, stat }) => {
    let url = `/download/numbers_by_date?start_date=${start_date}&end_date=${end_date}`;

    if (stat) {
      url += `&stat=${stat}`;
    }

    return {
      url,
      method: "GET",
      responseHandler: async (response) => {
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
          return await response.json();
        }

        return await response.blob();
      },
    };
  },
}),

downloadClickerReportByDate: builder.mutation({
  query: ({ start_date, end_date, stat }) => {
    let url = `/download/clicker_numbers_by_date?start_date=${start_date}&end_date=${end_date}`;

    if (stat) {
      url += `&stat=${stat}`;
    }

    return {
      url,
      method: "GET",
      responseHandler: async (response) => {
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
          return await response.json();
        }

        return await response.blob();
      },
    };
  },
}),

    getclickercustmerSmsreport: builder.query({
      query: ({ startdate, enddate }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        return `get-clicker-customer-report?${params.toString()}`;
      },
    }),
    getclickersmstotalreport: builder.query({
      query: ({ startdate, enddate }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        return `get-reseller-clicker-stat-count?${params.toString()}`;
      },
    }),
   getsmsapireportsummary: builder.query({
  query:({startdate, enddate})=>`/get-api-sms-summary?startdate=${startdate}&enddate=${enddate}`
   }),
   getresellerapismsreport: builder.query({
    query:({startdate, enddate, page, limit})=>`/get-reseller-customer-api-sms-requests?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`
   }),
   getCustomerScheduleReport: builder.query({
    query: ({ startdate, enddate, page, limit }) =>
      `/get-customer-schedule-report?startdate=${startdate}&enddate=${enddate}&page=${page}&limit=${limit}`,
   }),
  }),
});

export const {
  useGetSmsUploadSummaryQuery,
  useGetNumbersByCampaignQuery,
  useGetNumbersBySearchQuery,
  useGetSearchAcrossCampaignsQuery,
  useGetDownloadCampaignCSVMutation,
  useRequestSmsDownloadMutation,
  useSearchResellerNumberCampaignsQuery,
  useGetCustomerReportQuery,
  useGetApiSmsUploadSummaryQuery,
  useGetApiSmsByPhoneSearchQuery,
  useGetTodayApiSmsReportCSVMutation,
  useCeateMonthlyReportByCustomerMutation,
  useGetCustomerMonthlyReportQuery,
  useGetCustomerLogDeleteKeyQuery,
  useDeleteLogReportMutation,
  useGetConsolidatedReportQuery,
  useGetResellerCustomersQuery,
  useGetDownloadColumnNamesMutation,
  useGetDeliveryStatusCountQuery,
  useGetDashboardReportQuery,
  useGetLastMonthTrafficQuery,
  useGetLast7DaysTrafficQuery,
  useGetHourlyMISReportQuery,
  useGetResellerHourlyMISReportQuery,
  useGetHourlyMISDetailsQuery,
  useCheckFailedRefundQuery,
  useDownloadSmsReportMutation,
  useGetDownloadRequestListQuery,
  useGetResellerDeliveryStatusCountQuery,
  useDownloadSmsReportByDateMutation,
  useDownloadClickerReportByDateMutation,
  useGetclickercustmerSmsreportQuery,
  useGetclickersmstotalreportQuery,
  useGetsmsapireportsummaryQuery,
  useGetresellerapismsreportQuery,
  useGetCustomerScheduleReportQuery,
} = reportApi;
